
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.436 28.367H31.57v12.447H12.436V28.367zm1.887 1.881v8.685h15.36v-8.685h-15.36z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.325 12H13.688v7.049H9V47h42V19.049h-4.675V12zm1.08 33.119h1.708v-24.19h-2.788v2.655H13.688V20.93h-2.8v24.189H33.89V28.367h13.513v16.752zm-11.627 0h9.739V30.248h-9.74v14.871zM15.575 21.703v-7.822h28.863v7.822H15.575z"}})])
          )
        }
      }
    